var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositTreasure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 2.00293C12.3396 2.00293 12.6718 2.01944 12.999 2.05176V4.06543C12.673 4.02499 12.3408 4.00293 12.0039 4.00293C7.58575 4.0031 4.00391 7.5848 4.00391 12.0029C4.00416 16.4209 7.58591 20.0028 12.0039 20.0029C16.422 20.0029 20.0036 16.421 20.0039 12.0029C20.0039 10.9407 19.7948 9.92736 19.4189 9H21.5449C21.8429 9.94781 22.0039 10.9567 22.0039 12.0029C22.0036 17.5256 17.5265 22.0029 12.0039 22.0029C6.48135 22.0028 2.00416 17.5255 2.00391 12.0029C2.00391 6.48023 6.48119 2.0031 12.0039 2.00293ZM19.2568 3.56445H21.2715V5.56445H19.2568V7.66699H17.2559V5.56445H15.2715V3.56445H17.2559V1.66699H19.2568V3.56445Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50391 14.0029H14.0039C14.2801 14.0029 14.5039 13.779 14.5039 13.5029C14.5039 13.2268 14.2801 13.0029 14.0039 13.0029H10.0039C8.6232 13.0029 7.50391 11.8836 7.50391 10.5029C7.50391 9.12222 8.6232 8.00293 10.0039 8.00293H11.0039V7.00293H13.0039V8.00293H15.5039V10.0029H10.0039C9.72777 10.0029 9.50391 10.2268 9.50391 10.5029C9.50391 10.779 9.72777 11.0029 10.0039 11.0029H14.0039C15.3846 11.0029 16.5039 12.1222 16.5039 13.5029C16.5039 14.8836 15.3846 16.0029 14.0039 16.0029H13.0039V17.0029H11.0039V16.0029H8.50391V14.0029Z",
    fill: "#FAD228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositTreasure);
export default __webpack_public_path__ + "static/media/deposit-treasure.cac5774b7342dc50150692e155c71f09.svg";
export { ForwardRef as ReactComponent };